/**
 * This reducer is used to keep track of the last path.  The reason for storing it here
 * is because history.goBack() does not work properly in Safari and some versions of Firefox
 */

const routerLocations = (state = [], action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return [...state, action.payload.location.pathname];
    default:
      return state;
  }
};

export default routerLocations;